import service from '../allservices.jsx'


export function publicKey(actionCallback) {
    fetch(service.get_public_key, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                response.json().then(json => actionCallback(json, "success"))
            } else {
                response.json().then(json => actionCallback(json, "Error"))

            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/public_key.jsx